module.exports = __webpack_public_path__ + "static/media/summer-salads.a76ac4eb.jpeg";